import * as React  from 'react';
import { useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as _ from 'lodash';


import { fetchMiddlePanelLogsData, resetMiddlePanelInitialState, resetMiddlePanel,updateMiddlePanelLogsData } from '../../../../containers/WorkkardDetail/actions/action';
import LoaderComponent from '../../../../components/Loader';
import LogGroup from './logGroup';
import ListingComponent from '../../../../components/ListingComponent';
import { MiddlePanelConstant } from "../../../../containers/WorkkardDetail/constants";
import * as CommonUtil from '../../../../common/util';
import { formatEpochDateTime } from '../../../../common/util';
import Select from '../../../../components/Select';
import EmptyScreen from '../../../../Emptyscreen';
import { useLiveRefresh } from '../../../../utils/useLiveRefresh';

// API returns ASP.NET-style dates, e.g. "/Date(1786954908000)/"
const parseAspNetEpoch = (value) => {
    const match = typeof value === 'string' && /^\/Date\((-?\d+)(?:[+-]\d{4})?\)\/$/.exec(value);
    return match ? Number(match[1]) : null;
};

const Log = (props) => {
    const {
        history,
        workkard,
        activityDetail,
        middlePanel,
        isLoading,
        isMiddlePanelLoading,
        newLogLoading,
        timezone,
        fetchMiddlePanelLogsData,
        resetMiddlePanel,
        updateMiddlePanelLogsData,
    } = props;

    const { logs } = middlePanel;

    // keep the latest props reachable from the unmount cleanup closure
    const propsRef = useRef(props);
    propsRef.current = props;

    const isFirstRender = useRef(true);
    const prevActivityIdRef = useRef(activityDetail.activityId);

    const SeturlHash = (hash) => {
        let redirectPath = {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: `${hash}`
        }
        CommonUtil.redirectURL(history, redirectPath);
    }

    // switch between activity and workkard
    const onChangeType = (selectedValue) => {
        let selectedTab = selectedValue === MiddlePanelConstant.ActivityType ? 'a' : 'c'
        let hash = `${selectedTab}l`;
        SeturlHash(hash)
    }

    // function that handle if scroll on logs and fetch  next 10 notes, update redux state and rerender logs tab
    const onScrollHandler = () => {
        const { logs } = propsRef.current.middlePanel;
        const { skip, take} = logs;
        const payload = {
            type: logs.type,
            cId: propsRef.current.workkard.Id,
            actId: propsRef.current.activityDetail.activityId,
            skip: (skip === 0 && take > 10 ) ? take : parseInt(skip)+parseInt(take),
            take : (skip === 0 && take > 10 ) ? 10 : parseInt(take),
            sortBy: "0"
        }
        if (skip + take < logs.total) {
            propsRef.current.updateMiddlePanelLogsData(payload);
        }
    }

    // render every individual log cell in logs
    const renderLog = (logsData) => {
        if (logsData && logsData.length > 0) {
            const logIds = logsData.map(item=>{
                const keyObject = item.KeyObject || {};
                // API dates (e.g. "/Date(1786954908000)/") aren't already in the
                // "MM/DD/YYYY at h:mm A" shape LogGroup/LogCell expect, so re-derive it here.
                const epoch = parseAspNetEpoch(keyObject.CreatedDate);
                const createdDateString = (epoch != null && formatEpochDateTime(epoch, timezone))
                    || keyObject.CreatedDateString
                    || '';
                const normalizedItem = createdDateString !== keyObject.CreatedDateString
                    ? { ...item, KeyObject: { ...keyObject, CreatedDateString: createdDateString } }
                    : item;
                const date = (createdDateString || '').split('at');
                const createdAt = epoch ?? Date.parse(createdDateString.replace(' at ', ' '));
                return {id: keyObject.Id, date:date[0], time:date[1], data: normalizedItem, createdAt: Number.isNaN(createdAt) ? -Infinity : createdAt}
            });
            // Newest first: dates descending and, within a date, times descending.
            // Reversing first keeps entries with the same time in reverse API order (stable sort).
            const sortedLogIds = _.orderBy([...logIds].reverse(), 'createdAt', 'desc');
            const groupLogIds = _.groupBy(sortedLogIds, 'date');
            const prop = {
              data:Object.keys(groupLogIds).map(key=>({key,data:groupLogIds[key]})),
              cellTemplate: LogGroup,
              onScrollHandler: onScrollHandler,
              onItemClick: () => false,
              type:"div",
              selectedId: '',
              classname:'scrollArea',
              isCellLoading: newLogLoading,
              cellLoadingTemplate: <div className="logListing detailListing animated fast fadeIn"><LoaderComponent /></div>
            }

            return (
              <ListingComponent {...prop}/>
            );
        }
        return !(isLoading || isMiddlePanelLoading) && <EmptyScreen name="Emptylogs" type={middlePanel.logs.type} />;
    }

    const refreshLogsRef = useRef(null);
    refreshLogsRef.current = () => {
        const { middlePanel: panel, workkard: wk, activityDetail: detail } = propsRef.current;
        const { type, skip, take } = panel.logs;
        const actId = detail?.activityId || 0;
        if (type === MiddlePanelConstant.ActivityType && !actId) return;
        propsRef.current.fetchMiddlePanelLogsData({
            type,
            ...(type === MiddlePanelConstant.ActivityType ? { actId } : { cId: wk?.Id }),
            skip: 0,
            take: Math.max(parseInt(skip, 10) + parseInt(take, 10), 10),
            sortBy: "0",
        });
    };

    useLiveRefresh(['activity', 'note'], () => refreshLogsRef.current(), { workkardId: workkard?.Id });

    // fetch logs when component mount first time
    useEffect(() => {
        if (workkard) {

            const logsType = history.location.hash.charAt(2) === 'l' ?
                history.location.hash.charAt(1) === 'a' ? MiddlePanelConstant.ActivityType : MiddlePanelConstant.WorkkardType:
                middlePanel.logs.type;
            const fetchCondition = (logsType == MiddlePanelConstant.ActivityType && activityDetail.activityId > 0) || (logsType == MiddlePanelConstant.WorkkardType);
            onChangeType(logsType)
            const payload = {
                type: logsType,
                // actId: activityDetail.activityId
            }
            
            if (logsType === 'activity') {
                payload.actId = activityDetail.activityId;
            } else if (logsType === 'workkard') {
                payload.cId = workkard.Id;
            }

            if (fetchCondition) {
                fetchMiddlePanelLogsData(payload);
            } else {
                const payload = {
                    type: 'logs',
                    value: logsType,
                }
                resetMiddlePanel(payload);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch  Logs data when switch  between activity or  when switch  between workkard and activity
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            prevActivityIdRef.current = activityDetail.activityId;
            return;
        }

        const prevActivityId = prevActivityIdRef.current;
        const activityChanged = activityDetail.activityId !== prevActivityId;

        if (activityChanged && prevActivityId && logs.type === MiddlePanelConstant.ActivityType) {
            const payload = {
                type: 'logs',
                value: logs.type
            }
            resetMiddlePanel(payload)
        }

        if (activityChanged && logs.type === MiddlePanelConstant.ActivityType && activityDetail.activityId > 0) {
            fetchMiddlePanelLogsData({
                type: logs.type,
                actId: activityDetail.activityId,
            });
        }

        prevActivityIdRef.current = activityDetail.activityId;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activityDetail.activityId, logs.type]);

    useEffect(() => {
        return () => {
            const { logs } = propsRef.current.middlePanel;
            const payload = {
                type: 'logs',
                value: logs.type
            }
            propsRef.current.resetMiddlePanel(payload)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const selectOptions = [
        {
            label: MiddlePanelConstant.Log.ActivityTypeLog,
            value: MiddlePanelConstant.ActivityType
        },
        {
            label: MiddlePanelConstant.Log.WorkkardTypeLog,
            value: MiddlePanelConstant.WorkkardType
        }
    ]

    return (
        <React.Fragment>
            {(isLoading || isMiddlePanelLoading) &&
                <LoaderComponent />
            }
            <div className="filterBlock rowFlex">
                <div className="filterRight">
                    <div className="formGroup" data-test={`filter ${logs.type}`}>
                        <Select
                            options={selectOptions}
                            selected={(history.location.hash.charAt(1) === 'a' || logs.type=='activity')  ? MiddlePanelConstant.ActivityType : (history.location.hash.charAt(1) === 'c'  || logs.type=='workkard') ? MiddlePanelConstant.WorkkardType : undefined}
                            onSelect={(value) => {
                                onChangeType(value);
                                const payload = {
                                    type: 'logs',
                                    value: value,
                                }
                                resetMiddlePanel(payload);

                                const fetchCondition = (value === MiddlePanelConstant.ActivityType && activityDetail.activityId > 0) || (value === MiddlePanelConstant.WorkkardType);
                                if (fetchCondition) {
                                    const fetchPayload = { type: value };
                                    if (value === MiddlePanelConstant.ActivityType) {
                                        fetchPayload.actId = activityDetail.activityId;
                                    } else if (value === MiddlePanelConstant.WorkkardType) {
                                        fetchPayload.cId = workkard.Id;
                                    }
                                    fetchMiddlePanelLogsData(fetchPayload);
                                }
                            }
                            }
                            openOnClick={true}
                            iconName="downArrow"
                            styleClass="ml"
                            isOpenRight={true}
                        />
                    </div>
                </div>
            </div>
            <div className={!(isLoading || isMiddlePanelLoading) && logs && logs.data.length < 1 ?"logMainContainer detailMainContainer noDataFound":"logMainContainer detailMainContainer"}>
                {
                    (logs
                        &&
                        logs.data
                        &&
                        renderLog(logs.data))
                }
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    activityDetail: state.workkardDetail.activityDetail,
    workkard: state.workkardDetail.workkardDetail,
    middlePanel : state.workkardDetail.middlePanel,
    isMiddlePanelLoading : state.workkardDetail.middlePanel.isLoading,
    isLoading: state.isLoading,
    newLogLoading: state.workkardDetail.buttonLoaders.newLog,
    timezone: state.sessionContextOidc?.userView?.timezone
});

const mapDispatchToProps = (dispatch) => ({
    fetchMiddlePanelLogsData: bindActionCreators(fetchMiddlePanelLogsData, dispatch),
    resetMiddlePanel: bindActionCreators(resetMiddlePanel, dispatch),
    resetMiddlePanelInitialState: bindActionCreators(resetMiddlePanelInitialState, dispatch),
    updateMiddlePanelLogsData:bindActionCreators(updateMiddlePanelLogsData,dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Log);